import type { SVGProps } from 'react';
export const SvgEye = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#AAA"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
		/>
		<path
			stroke="#AAA"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M2.048 10a8.337 8.337 0 0 1 15.904 0 8.337 8.337 0 0 1-15.904 0"
		/>
	</svg>
);
